import React from "react";
import { ViewportContext } from "shared/context/ViewportContext";

const useViewport = () => React.useContext(ViewportContext);

export default useViewport;
